import type {
  RecommendedArticle,
  RecommendedModel,
  RecommendedProduct,
} from '../../../generated/frontend'

export type RecommendedContentType = RecommendedArticle | Partial<RecommendedProduct>

export type RecommendedModelType = {
  content: RecommendedContentType[]
  model: RecommendedModel['model']
}

export type RecommendationsType = {
  models: RecommendedModelType[]
}

export enum Model {
  CF_PAGE_LEVEL = 'segment/content_recommendation_cf_page_level',
  CF_PRODUCT_CATEGORY_LEVEL = 'segment/content_recommendation_collaborative_filtering',
  MIXED_ADVICE = 'segment/mixed/adviceOnly',
}

const getModel = (
  models: RecommendedModelType[],
  modelName: string
): RecommendedModelType | null => {
  const model = models.find((model) => model.model == modelName)
  const hasRecommendations = model?.content && model.content.length > 0

  if (!hasRecommendations) {
    return null
  }

  return model
}

export type ModelsDataType = Record<Model, RecommendedModelType | null>

export const getModelsData = (models: RecommendedModelType[]): ModelsDataType => {
  return {
    [Model.CF_PAGE_LEVEL]: getModel(models, Model.CF_PAGE_LEVEL),
    [Model.CF_PRODUCT_CATEGORY_LEVEL]: getModel(models, Model.CF_PRODUCT_CATEGORY_LEVEL),
    [Model.MIXED_ADVICE]: getModel(models, Model.MIXED_ADVICE),
  }
}
